import { GridColDef } from '@mui/x-data-grid-premium';
import React from 'react';
import { tableSettingsProps, useTableSettings } from 'src/core/tables/useTableSettings';
import tableHelper from 'src/core/tables/tableHelper';
import { useGetAllBackorders } from 'src/pages/purchasing/purchasingRequests';

export const useBackordersTable = (): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const { rows, status } = useGetAllBackorders();
  const statusOptions = tableHelper.getSelectOptionsFromKeyValuePair(rows, 'Status');
  const idPath = ['ArticleNumber'];
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'ArticleNumber', headerName: 'Article Number', width: 70 },
      { field: 'Article', headerName: 'Article', minWidth: 180, width: 180, valueGetter: tableHelper.getFieldKeyOrValue, flex: 1 },
      { field: 'Status_Value', headerName: 'Status', valueGetter: tableHelper.getFieldKeyOrValue, renderCell: tableHelper.renderStatusCell, type: 'singleSelect', valueOptions: statusOptions },
      { field: 'TotalQty', headerName: 'Total Qty', type: 'number' },
      { field: 'Warehouse', headerName: 'Warehouse', flex: 1 },
      { field: 'ProductType_Value', headerName: 'Product Type', valueGetter: tableHelper.getFieldKeyOrValue },
      { field: 'Manufacturer_Value', headerName: 'Manufacturer', valueGetter: tableHelper.getFieldKeyOrValue },
      { field: 'ManufacturerProdId', headerName: 'Manufacturer Prod Id' },
      { field: 'LastCreatedDate', headerName: 'Last Created Date', type: 'dateTime', valueGetter: tableHelper.getDateColumn }
    ],
    [statusOptions]
  );
  const tableName = 'BackordersTable';
  const tableSettings = useTableSettings({ tableName, idPath, columns, rows, status, defaultColumnVisibilityModel: { ManufacturerProdId: false } });
  return [columns, tableSettings];
};

export const useBackordersRowsTable = (rows = []): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const idPath = ['OrderNr'];
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'OrderNr', headerName: 'OrderNr' },
      { field: 'SourceDestination', headerName: 'Source Destination' },
      { field: 'SourceDestinationName', headerName: 'Source Destination Name', flex: 1 },
      { field: 'User', headerName: 'User', flex: 1 },
      { field: 'Quantity', headerName: 'Quantity', type: 'number' },
      { field: 'SourceName', headerName: 'Source Name' },
      { field: 'ETA', headerName: 'ETA' },
      { field: 'Date', headerName: 'Date', type: 'dateTime', valueGetter: tableHelper.getDateColumn }
    ],
    []
  );
  const tableName = 'BackordersRowsTable';
  const tableSettings = useTableSettings({ tableName, idPath, columns, rows });
  tableSettings.hasToolbar = false;
  tableSettings.autoHeight = true;
  tableSettings.loading = false;
  tableSettings.hideFooter = true;
  return [columns, tableSettings];
};

